<template>
    <AddPublication />
    
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import AddPublication from "@/components/Publication/AddPublication.vue";
  
    export default defineComponent({
      name: "AddPublicationPage",
      components: {
        
        AddPublication,
      },
    });
  </script>